module.exports = __webpack_public_path__ + "static/media/event-1.e3a9e81c.jpg";